import { render, staticRenderFns } from "./OrderDetailRedirect.vue?vue&type=template&id=53975a37&scoped=true"
import script from "./OrderDetailRedirect.vue?vue&type=script&lang=js"
export * from "./OrderDetailRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53975a37",
  null
  
)

export default component.exports